module.exports = __webpack_public_path__ + "static/media/close-icon-menu.92e79c8c.svg";